import * as React from 'react'
import { AuthContext } from 'contexts/authContext'

/**
 * Custom hook to provide an authenticated fetch function.
 */
const useFetchWithAuth = () => {
  const { user, dispatch } = React.useContext(AuthContext)

  return React.useCallback(
    async (url, options = {}) => {
      if (!user || !user.accessToken) {
        dispatch({ type: 'LOGOUT' })
        return Promise.reject(new Error('Requires user authentication'))
      }

      const fetchOptions = {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${user.accessToken}`,
        },
        credentials: 'include',
      }

      return fetch(url, fetchOptions).then((response) => {
        if (!response.ok && response.status === 401) {
          dispatch({ type: 'LOGOUT' })
          return Promise.reject(new Error('Requires user authentication'))
        }

        return response
      })
    },
    [user, dispatch] // Memoize the function so it's not recreated unnecessarily
  )
}

export default useFetchWithAuth
